export const translate = (key, fallback) => window.__litium.translation[key] || fallback || key;
